import {Component, Input, OnInit} from '@angular/core';
import {ProductService} from '../../services/product.service';
import {AppService} from '../../services/app.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-autosearch',
  templateUrl: './autosearch.component.html',
  styleUrls: ['./autosearch.component.css']
})
export class AutosearchComponent implements OnInit {

  public isStandardProduct = false;

  constructor(
    private productService: ProductService,
    private appService: AppService,
    private router: Router
  ) {
  }

  @Input()
  get standardProduct(): boolean {
    return this.isStandardProduct;
  }

  set standardProduct(flag: boolean) {
    this.isStandardProduct = flag;
  }

  ngOnInit(): void {
  }

  keyword = 'name';
  data = [];

  selectEvent(item): void {
    // do something with selected item
    console.log('selected item', item);
    this.router.navigate(['/' + item.city.name.toLowerCase() + '/' + item.slug]);
  }

  onChangeSearch(val: string): void {
    // fetch remote data from here
    // And reassign the 'data' which is binded to 'data' property.

    localStorage.setItem('searchKeyword', val);

    if (val) {

      if (this.isStandardProduct) {
        this.productService.searchExperiences(this.appService.getCurrentCity(), val).subscribe(response => {
            if (response) {
              this.data = [];
              response.data.data.forEach(item => {
                item.name = item.title;
                this.data.push(item);
              });
            }
          },
          error => {
            console.error('There was an error!', error);
          });
      } else {
        this.productService.searchExclusive(this.appService.getCurrentCity(), val).subscribe(response => {
            if (response) {
              this.data = [];
              response.data.data.forEach(item => {
                item.name = item.title;
                this.data.push(item);
              });
            }
          },
          error => {
            console.error('There was an error!', error);
          });
      }
    }else{
      this.data = [];
    }

  }

  onFocused(e): void {
    // do something when input is focused
  }
}
